import {Paper, PaperProps, styled} from "@mui/material";

export const OrderPopupContainer = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1rem',
}));

export const OrderPopupCard = styled((props: PaperProps) => (
    <Paper {...props} elevation={0}/>
))(() => ({
    backgroundColor: '#fff',
    width: '100%',
    maxWidth: '43rem',
}));

export const OrderPopupCardTitle = styled('div')(() => ({
    padding: '0 0.5rem',
    marginBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'flex-start'
}));
